import React from 'react'

import EN from './en'

import '../css/App.css'

export default () => {
  return <EN />
}
